<template>
    <CustomDialog v-model="isVisible" :defaultTitle="title" heightClass="ppv2-max-h-[40vh]" :isInPopup="true">
        <template #actions>
            <BaseButton
                variant="outline"
                @click="handleCancel"
                customClass="!ppv2-min-h-[40px]"
                :customHeight="43"
                :disabled="loading"
            >
                {{ cancelText }}
            </BaseButton>
            <BaseButton
                variant="primary"
                @click="handleConfirm"
                customClass="!ppv2-min-h-[40px]"
                :customHeight="43"
                :disabled="loading"
            >
                {{ confirmText }}
            </BaseButton>
        </template>
    </CustomDialog>
</template>

<script>
import CustomDialog from '../../Shared/CustomDialog.vue'
import BaseButton from '../../Shared/BaseButton.vue'

export default {
    name: 'VoucherToggleModal',
    components: {
        CustomDialog,
        BaseButton,
    },
    props: {
        modalId: {
            type: String,
            default: 'modal-toggle-voucher',
        },
        title: {
            type: String,
            default: 'Confirmation',
        },
        confirmText: {
            type: String,
            default: 'Confirmer',
        },
        cancelText: {
            type: String,
            default: 'Fermer',
        },
        loading: {
            type: Boolean,
            default: false,
        },
        show: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['confirm', 'cancel', 'close'],
    computed: {
        isVisible: {
            get() {
                return this.show
            },
            set(value) {
                if (!value) {
                    this.$emit('close')
                }
            },
        },
    },
    methods: {
        handleConfirm() {
            this.$emit('confirm')
        },
        handleCancel() {
            this.$emit('cancel')
        },
    },
}
</script>

<style scoped></style>
